import React__default from 'react';
import { Icon } from '../components/internal/Icon.mjs';

function SendIcon(props) {
  return /* @__PURE__ */ React__default.createElement(Icon, {
    ...props
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "m5 16 12-6L5 4l2 6-2 6ZM7 10h10"
  }));
}

export { SendIcon };
//# sourceMappingURL=Send.mjs.map
